module.exports = __webpack_public_path__ + "static/media/combo-chart-icon.04002336.svg";